// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig, headingsFontConfig } from "@flip/XDL/PreStyle/typography";
import { ellipsis } from "@flip/XDL/Utilities";
import { mergeWithCss } from "@flip/XDL/Utilities/mergeWithCss";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import { TypographyProps } from "@insite/mobius/Typography";
import { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

interface ProductDescriptionVariantStyles {
    small?: ProductDescriptionStyles;
    medium?: ProductDescriptionStyles;
}

const sharedStyles: { [key in keyof ProductDescriptionVariantStyles]: StyledProp } = {
    small: css`
        min-height: 30px;
        margin-bottom: 12px;
        align-items: flex-start;
    `,
    medium: css`
        min-height: 34px;
        margin-bottom: 16px;
        align-items: flex-start;
    `,
};
const sharedSmallTextStyles: TypographyProps = {
    size: 14,
    weight: fontConfig.weight.bold,
    color: "text.main",
    fontFamily: fontConfig.fontFamily,
    css: css`
        letter-spacing: 0;
        line-height: 16px;
        vertical-align: unset;
        ${wrapInContainerStyles};
        ${ellipsis(2)}
    `,
};
const sharedMediumTextStyles: TypographyProps = {
    size: 32,
    weight: headingsFontConfig.weight.bold,
    color: "text.main",
    fontFamily: headingsFontConfig.fontFamily,
    css: css`
        letter-spacing: 0;
        line-height: 40px;
        vertical-align: unset;
        ${wrapInContainerStyles}
    `,
};

const productDescriptionVariantStyles: ProductDescriptionVariantStyles = {
    small: {
        productDetailDescription: {
            ...mergeWithCss(sharedSmallTextStyles, { css: sharedStyles.small }),
        },
        productDetailLink: {
            ...mergeWithCss(
                {
                    color: "text.main",
                    typographyProps: {
                        ...sharedSmallTextStyles,
                    },
                    
                },
                { css: sharedStyles.small },
            ),
        },
    },
    medium: {
        productDetailDescription: {
            ...mergeWithCss(sharedMediumTextStyles, { css: sharedStyles.medium }),
        },
        productDetailLink: {
            ...mergeWithCss(
                {
                    color: "text.main",
                    typographyProps: {
                        ...sharedMediumTextStyles,
                    },
                },
                { css: sharedStyles.medium },
            ),
        },
    },
};

export default productDescriptionVariantStyles;
